import {
    GET_CHILD_GUARDIAN_INVOICES,
    GET_CHILD_GUARDIAN_INVOICE,
    SET_CHILD_GUARDIAN_INVOICES,
    SET_CHILD_GUARDIAN_INVOICE,
    SET_CHILD_GUARDIAN_SERVICES,
    SET_CHILD_GUARDIAN_INVOICE_SETTINGS,
    STORE_CHILD_GUARDIAN_SERVICE,
    SET_CHILD_GUARDIAN_SERVICE,
    ADD_CHILD_GUARDIAN_SERVICE,
    UPDATE_CHILD_GUARDIAN_SERVICE,
    DELETE_CHILD_GUARDIAN_SERVICE,
    REMOVE_CHILD_GUARDIAN_SERVICE,
    UPDATE_CHILD_GUARDIAN_FEE,
    UPDATE_CHILD_GUARDIAN_FEE_SETTINGS
} from './actions';
import Vue from 'vue';
import ChildService from '@services/child.service';
const getDefaultState = () => {
    return {
        invoices: {
            data: []
        },
        invoice: {
            rows: [],
            child: {}
        },
        services: [],
        settings: {}
    };
};
export const childGuardianInvoicesState = getDefaultState();
export const childGuardianInvoicesMutations = {
    [SET_CHILD_GUARDIAN_INVOICES](state, data) {
        state.invoices = data;
    },
    [SET_CHILD_GUARDIAN_INVOICE] (state, data) {
        state.invoice = data;
    },
    [SET_CHILD_GUARDIAN_SERVICES](state, data) {
        state.services = data;
    },
    [SET_CHILD_GUARDIAN_INVOICE_SETTINGS] (state, data) {
        state.settings = data;
    },
    [ADD_CHILD_GUARDIAN_SERVICE] (state, data) {
        state.services.push(data);
    },
    [SET_CHILD_GUARDIAN_SERVICE] (state, data) {
        const index = state.services.findIndex(s => s.id === data.id);
        if(index > -1) {
            Vue.set(state.services, index, data);
        }
    },
    [REMOVE_CHILD_GUARDIAN_SERVICE](state, id) {
        state.services = state.services.filter(s => s.id != id);
    },
    [UPDATE_CHILD_GUARDIAN_FEE_SETTINGS](state, data) {
        state.settings.invoice_unit_price = data.invoice_unit_price;
        state.settings.invoice_discount = data.invoice_discount;
    }
};
export const childGuardianInvoicesActions = {
    [GET_CHILD_GUARDIAN_INVOICES] ({commit, getters}, {childId, queryObj}) {
        return ChildService.getGuardianInvoices(getters.activeKindergartenId, childId, queryObj).then(res => {
            commit(SET_CHILD_GUARDIAN_INVOICES, res.invoices);
            if(queryObj.services && res.services) {
                commit(SET_CHILD_GUARDIAN_SERVICES, res.services);
            }
            if(queryObj.settings && res.settings) {
                commit(SET_CHILD_GUARDIAN_INVOICE_SETTINGS, res.settings);
            }
        });
    },
    [GET_CHILD_GUARDIAN_INVOICE]({commit, getters}, {childId, invoiceId}) {
        return ChildService.getGuardianInvoice(getters.activeKindergartenId, childId, invoiceId).then(res => {
            commit(SET_CHILD_GUARDIAN_INVOICE, res);
        });
    },
    [STORE_CHILD_GUARDIAN_SERVICE]({commit, getters}, {childId, data}) {
        return ChildService.addGuardianInvoiceService(getters.activeKindergartenId, childId, data).then(res => {
            commit(ADD_CHILD_GUARDIAN_SERVICE, res);
        });
    },
    [UPDATE_CHILD_GUARDIAN_SERVICE]({commit, getters}, {childId, serviceId, data}) {
        return ChildService.updateGuardianInvoiceService(getters.activeKindergartenId, childId, serviceId, data).then(res => {
            commit(SET_CHILD_GUARDIAN_SERVICE, res);
        });
    },
    [DELETE_CHILD_GUARDIAN_SERVICE]({commit, getters}, {childId, serviceId}) {
        return ChildService.deleteGuardianInvoiceService(getters.activeKindergartenId, childId, serviceId).then(() => {
            commit(REMOVE_CHILD_GUARDIAN_SERVICE, serviceId);
        });
    },
    [UPDATE_CHILD_GUARDIAN_FEE]({commit, getters}, {childId, data}) {
        return ChildService.updateChildGuardianFee(getters.activeKindergartenId, childId, data).then(res => {
            commit(UPDATE_CHILD_GUARDIAN_FEE_SETTINGS, res);
        });
    }
};

export const childGuardianInvoicesGetters = {
    childGuardianInvoices: state => state.invoices,
    childGuardianInvoice: state => state.invoice,
    childGuardianServices: state => state.services,
    childGuardianInvoiceSettings: state => state.settings
};
